var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.143 19H2.857C1.28 19 0 17.693 0 16.08v-3.65c0-.404.32-.73.714-.73h1.429c.394 0 .714.326.714.73v2.19c0 .806.64 1.46 1.429 1.46h11.428c.79 0 1.429-.654 1.429-1.46v-2.19c0-.404.32-.73.714-.73h1.429c.394 0 .714.326.714.73v3.65c0 1.613-1.279 2.92-2.857 2.92ZM4.193 4.676a.73.73 0 0 1 1.047 0l3.332 3.406V.73c0-.403.32-.73.714-.73h1.428c.395 0 .715.327.715.73v7.352l3.331-3.406a.729.729 0 0 1 1.047 0l1.047 1.07a.769.769 0 0 1 0 1.07l-5.9 6.03c-.025.026-.484.313-.946.313-.467 0-.936-.286-.962-.313l-5.9-6.03a.769.769 0 0 1 0-1.07l1.047-1.07Z",
    fill: "#9596A3",
    fillRule: "nonzero"
  })));
};
export default SvgDownload;